import { configManager } from '@/Core/Managers/Config'
import { UserManager } from '@/Core/Managers/User'

export const MercureHandler = ({ crudContext, response, loadData }) => {
    const appConfig = configManager.get('AppConfig')

    if (!appConfig?.mercureUrl) return

    if (typeof window.wlMercureTopics === 'object') {
        window.wlMercureTopics.close()
    }

    const url = new URL(appConfig.mercureUrl)

    url.searchParams.append('topic', response['@id'])
    url.searchParams.append('authorization', UserManager.mercureToken)
    const eventSource = new EventSource(url)

    eventSource.onmessage = (e) => {
        const result = JSON.parse(e.data)
        // const message = result.message;
        // const link = result.link ? result.link : null;
        loadData()
    }

    window.wlMercureTopics = eventSource

    window.addEventListener(
        'beforeunload',
        function (e) {
            eventSource.close()
            return null
        },
        false
    )
}
